import { render } from "./share-modal-content.vue?vue&type=template&id=02971924&scoped=true&ts=true"
import script from "./share-modal-content.vue?vue&type=script&lang=ts"
export * from "./share-modal-content.vue?vue&type=script&lang=ts"

import "./share-modal-content.vue?vue&type=style&index=0&id=02971924&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02971924"]])

export default __exports__